const userInfoKey = 'user-info-app';

export default userInfoKey;
